exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".cloud-provider-logo .icon-ecs {\n  background: url(" + require("./ecs.icon.svg") + ") no-repeat 50% 50%;\n  background-size: cover;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib!./node_modules/less-loader/dist/cjs.js!./app/scripts/modules/ecs/logo/ecs.logo.less
// module id = 3950
// module chunks = 0